import type { IntegrationDataHook } from "@/features/integrations/shared/renderer/hooks/types";

const integrationDataHooksRegistry = new Map<string, IntegrationDataHook>();

export function registerCampaignsIntegrationDataHook(
  integrationName: string,
  hook: IntegrationDataHook
): void {
  integrationDataHooksRegistry.set(integrationName.toLowerCase(), hook);
}

export function getCampaignsIntegrationDataHook(
  integrationName: string | undefined
): IntegrationDataHook | undefined {
  if (!integrationName) return undefined;
  return integrationDataHooksRegistry.get(integrationName.toLowerCase());
}
